import React from 'react'
import { Icon } from '@chakra-ui/react'
import { FaSearch } from 'react-icons/fa'
import { Input, InputGroup, InputLeftElement } from '@chakra-ui/react'

interface Props {
    value: string
    onChange: (value: string) => void
}

export default function SearchBar({ value, onChange }: Props) {
    return (
        <InputGroup size="sm">
            <InputLeftElement>
                <Icon as={FaSearch} color="gray.500" />
            </InputLeftElement>
            <Input
                value={value}
                onChange={e => onChange(e.target.value)}
                rounded="lg"
                placeholder="Search all your clients..."
            />
        </InputGroup>
    )
}
